import React, { Fragment, useEffect, useContext, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import ProjectState from './context/project/ProjectState'
import InfoContext from './context/info/infoContext'

import './App.css';
import './scss/main.scss';
import Home from './components/Home/Home';
import About from './components/About/About';
import Preloaders from './components/Preloaders/Preloaders';

const Work = lazy(() => import('./components/Work/Work'));

function App() {

  useEffect(() => {

    let mounted = true;

    if(mounted){

      getAllEducations();
      getAllIntros();
      getAllSkills();
      getAllSocials();
      getAllJourneys();

    }
    return () => {
      mounted = false;
    }
    // eslint-disable-next-line
  },[])

  useEffect(() => {
    document.body.style.height = '100vh'
    document.body.style.width = '100vw'
    // eslint-disable-next-line
  },[]);

  const infoContext = useContext(InfoContext);

  const { loading, getAllIntros, getAllSocials, getAllSkills, getAllEducations, getAllJourneys } = infoContext;

  if(loading){
    return <Preloaders />
  }

  return (
    <div className="App">
    <ProjectState>
    <Fragment>
      <Router>
        <Switch>
          <Route exact path='/' component={Home} />
          <Route exact path='/about' component={About} />
          <Suspense fallback={<Preloaders />}>
            <Route exact path='/work' component={Work} />
          </Suspense>
        </Switch>
      </Router>
    </Fragment>
    </ProjectState>
    </div>
  );
}

export default App;
